import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import { Form, Field } from 'react-final-form';
import { FORM_ERROR } from 'final-form';
import { TextField } from '../../atoms';
import { Button, Col, Row } from 'antd';
import { connect } from 'react-redux';
import validateSchema from './validateSchema';
import RegisterActions from '../../components/RegisterActions/RegisterActions';
import {
  FORM_LU_ADD_GENERAL,
  loadingUnitStatus,
  luGeneralFormFields,
} from '../../constants/loadingUnit';
import {
  activateLoadingUnitAction,
  addLoadingUnitAction,
  deactivateLoadingUnitAction,
  selectOwnerActionCreator,
  updateLoadingUnitAction,
} from '../../actions/actionCreators/loadingUnitActionCreator';
import { parseMegawatt } from '../../utils/formHelpers';
import { AutoCompleteCompanies } from '../../components';
import { legalEntityFields } from '../../constants/legalEntity';
import { legalEntityStatus } from '../../constants/classificators';
import FormStateToRedux from '../FormStateToRedux';
import { makeRffValidateFromLegacy } from '../rffLegacyValidateAdapter';

export class AddLoadingUnitGeneral extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    hasPrevious: PropTypes.bool,
    hasDone: PropTypes.bool,
    goPrevious: PropTypes.func,
    inEditForNotAdmin: PropTypes.bool.isRequired,
    isEditMode: PropTypes.bool.isRequired,
    isAdmin: PropTypes.bool.isRequired,
    legalEntityId: PropTypes.number,
    activate: PropTypes.func.isRequired,
    deactivate: PropTypes.func.isRequired,
    addLoadingUnit: PropTypes.func.isRequired,
    updateLoadingUnit: PropTypes.func.isRequired,
    allowToSelectCompany: PropTypes.bool,
    onSubmitSuccess: PropTypes.func,
    initialValues: PropTypes.object,
    selectOwner: PropTypes.func,
  };

  onSubmit = async (values) => {
    const hasId = !!values[luGeneralFormFields.ID];
    const payload = hasId
      ? values
      : {
          ...values,
          [luGeneralFormFields.LEGAL_ENTITY_ID]: this.props.legalEntityId,
        };

    const result = hasId
      ? await this.props.updateLoadingUnit(payload)
      : await this.props.addLoadingUnit(payload);

    if (result?.error) {
      return { [FORM_ERROR]: 'submitFailed' };
    }

    this.props.onSubmitSuccess?.();
  };

  render() {
    const {
      hasPrevious,
      hasDone,
      goPrevious,
      t,
      isEditMode,
      isAdmin,
      initialValues,
      activate,
      deactivate,
      legalEntityId,
      selectOwner,
      allowToSelectCompany,
    } = this.props;

    const iv = initialValues || {};
    const unitStatus = iv[luGeneralFormFields.STATUS];
    const unitId = iv[luGeneralFormFields.ID];

    const validate = makeRffValidateFromLegacy(validateSchema, this.props);

    return (
      <div>
        {isAdmin && allowToSelectCompany && (
          <AutoCompleteCompanies
            onChange={selectOwner}
            companiesFilter={(item) =>
              item[legalEntityFields.STATUS] === legalEntityStatus.ACTIVE &&
              item[legalEntityFields.LOADING_OPERATOR]
            }
            value={legalEntityId}
          />
        )}
        <Form
          onSubmit={this.onSubmit}
          initialValues={iv}
          initialValuesEqual={isEqual}
          validate={validate}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <FormStateToRedux form={FORM_LU_ADD_GENERAL} />
              <h2>{t('general.title')}</h2>
              <Row gutter={32}>
                <Col span={12}>
                  <Field
                    label={t('general.name')}
                    tooltip={t('general.nameTooltip')}
                    required
                    name={luGeneralFormFields.NAME}
                    component={TextField}
                  />
                </Col>
                <Col span={12}>
                  <Field
                    name={luGeneralFormFields.POWER}
                    component={TextField}
                    addonAfter={t('general.power.units')}
                    type="text"
                    parse={parseMegawatt}
                    label={t('general.power.label')}
                    required
                  />
                </Col>
              </Row>
              <Row gutter={32}>
                <Col span={12}>
                  <Field
                    name={luGeneralFormFields.UNIT_MODEL}
                    component={TextField}
                    required
                    type="text"
                    label={t('general.unitModel')}
                  />
                </Col>
              </Row>
              <RegisterActions
                hasPrevious={hasPrevious}
                hasDone={hasDone}
                isEditMode={isEditMode}
                isAdmin={isAdmin}
                goPrevious={goPrevious}
                showSaveButton={true}
                showRequestChangeButton={false}
                t={t}
              >
                {unitId && isEditMode && isAdmin && (
                  <Button
                    size="large"
                    type="primary"
                    onClick={
                      unitStatus === loadingUnitStatus.ACTIVE
                        ? () => deactivate(unitId)
                        : () => activate(unitId)
                    }
                  >
                    {unitStatus === loadingUnitStatus.ACTIVE
                      ? t('general.deactivateBtn')
                      : t('general.activateBtn')}
                  </Button>
                )}

                {unitId &&
                  isEditMode &&
                  !isAdmin &&
                  unitStatus === loadingUnitStatus.ACTIVE && (
                    <Button
                      size="large"
                      type="primary"
                      onClick={() => deactivate(unitId)}
                    >
                      {t('general.deactivateBtn')}
                    </Button>
                  )}
              </RegisterActions>
            </form>
          )}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const initialValues = ownProps.loadingUnit?.toJS
    ? ownProps.loadingUnit.toJS()
    : ownProps.loadingUnit || {};
  return {
    initialValues,
  };
};

const mapDispatchToProps = {
  selectOwner: selectOwnerActionCreator,
  activate: activateLoadingUnitAction,
  deactivate: deactivateLoadingUnitAction,
  addLoadingUnit: addLoadingUnitAction,
  updateLoadingUnit: updateLoadingUnitAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddLoadingUnitGeneral);
